document.addEventListener('DOMContentLoaded', () => {
  const eventSelect = document.getElementById('event');
  const dateSelect = document.getElementById('event-date');

  eventSelect.addEventListener('change', () => {
    const selectedOption = eventSelect.options[eventSelect.selectedIndex];
    const datesString = selectedOption.dataset.dates || '';

    dateSelect.innerHTML = '';

    const defaultOption = document.createElement('option');
    defaultOption.value = '';
    defaultOption.textContent = 'Select a date';
    dateSelect.appendChild(defaultOption);

    if (datesString.trim() !== '') {
      const dates = datesString.split(/[,;]+/).map(d => d.trim()).filter(Boolean);

      dates.forEach(dateStr => {
        const opt = document.createElement('option');
        opt.value = dateStr;
        opt.textContent = dateStr;
        dateSelect.appendChild(opt);
      });

      dateSelect.disabled = false;
    } else {
      dateSelect.disabled = true;
    }
  });
});